<template>
  <article>
    <TourItem
      class="tour-item--1"
      contentCol="col--lg-7 col--md-10"
      mediaCol="col--lg-5"
      right
    >
      <h1>Choice Hacking Chooses Campsite.bio as her #1 Bio Link Tool</h1>
      <p>Some of the features that Jen loves:</p>
      <ul style="margin-bottom: 1em">
        <li>⛺️ A professional look with our profile customization features</li>
        <li>⛺️ Embedding content like podcasts, music, and videos</li>
        <li>⛺️ Collecting email opt-ins to grow her email list</li>
        <li>⛺️ Advanced analytics and insights</li>
      </ul>
      <Button
        href="https://app.campsite.bio/create-account"
        size="large"
        color="secondary"
        variant="hard-shadow"
        >Get Started for Free</Button
      >

      <div class="tour-item__device-wrapper" slot="media">
        <ScaledDevice class="device" :width="428" :height="868" ref="preview">
          <DeviceIphone>
            <nuxt-img
              src="/campsites/creators/campsite-choicehacking.png"
              :sizes="`xs:500px`"
              :quality="85"
              alt="Campsite.bio profile"
            />
          </DeviceIphone>
        </ScaledDevice>
      </div>
    </TourItem>

    <SeenOn />

    <section class="choicehacking-quote grid grid--container">
      <Rte>
        <img
          src="~/assets/images/landing/review-stars.png"
          alt=" 5/5 stars"
          loading="lazy"
        />
        <h2>Campsite.bio has helped my business and my audience grow</h2>
        <blockquote>
          <p>
            Having a professional link in bio page is really important to my
            business since most of my traffic comes from different social
            channels like Instagram, Twitter, and LinkedIn - Campsite's features
            have helped me look professional and their embed features have
            increased my email opt-ins, product sales, and YouTube and podcast
            downloads. Their analytics features are great too.
          </p>
          <p>
            I can't recommend Campsite enough if you're looking for a
            professional link in bio to grow your business.
          </p>
          <cite>- Jennifer Clinehens</cite>
        </blockquote>
      </Rte>
    </section>

    <ConfigSection />
    <ProfilesSection />
    <ProSection
      button-text="Become a Pro"
      button-url="https://app.campsite.bio/create-account"
    />
  </article>
</template>

<script>
import {
  Button,
  ScaledDevice,
  DeviceIphone,
} from '@campsite-bio/component-lib';

import TourItem from '@/components/tour-item';
import SeenOn from '@/components/seen-on-analytics';
import ConfigSection from '@/components/home/config-section/config-section';
import ProfilesSection from '@/components/home/profiles-section/profiles-section';
import ProSection from '@/components/home/pro-section/pro-section';
import Rte from '@/components/rte';
import { useMediaQuery } from '@vueuse/core';
import { generateMeta } from '~/utils/generate-meta';

export default {
  components: {
    Button,
    SeenOn,
    ConfigSection,
    ProfilesSection,
    ProSection,
    TourItem,
    Rte,
    ScaledDevice,
    DeviceIphone,
  },

  head() {
    return generateMeta({
      title: "Choice Hacking's #1 link in bio tool - Campsite.bio",
      description:
        'See why Jen from Choice Hacking chose Campsite.bio for her link in bio tool. She loves the professional look, the ability to embed content, and the advanced analytics features.',
    });
  },

  layout: 'landing',

  setup() {
    const isLargerScreen = useMediaQuery('(min-width: 768px)');

    return {
      isLargerScreen,
    };
  },
};
</script>

<style lang="scss" scoped>
.device {
  margin: 0 auto;
  width: 250px;
  z-index: 1;

  @media (min-width: 992px) {
    width: 344px;
  }

  &::v-deep {
    img {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;

      &:first-child {
        z-index: 1;
      }
    }
  }
}

.choicehacking-quote {
  padding-top: 3rem;

  > div {
    font-size: 1.25rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  img {
    margin-bottom: -1.5rem;
  }

  blockquote {
    background: none;
    border-left: none;
    font-size: 1em;

    @media (min-width: 544px) {
      font-size: 1.25em;
    }

    cite {
      color: var(--g-color-on-bg);
      font-style: normal;
      font-size: 1rem;
      font-weight: 600;
    }
  }
}
</style>
